/* Transformations carousel
   --------------------------------------------------------------------------
   The scrolling itself is the browser's: the track is a scroll-snap container,
   so touch, trackpad and shift-wheel already work and keyboard users can tab
   through the slides. This file adds only what native scrolling has no opinion
   about - the two arrow buttons, and whether they should exist at all.

   An arrow that cannot move anything is worse than no arrow, so both are
   hidden whenever the track is not overflowing (three cases on a desktop do
   not fill the row) and each is hidden again once its end is reached.

   Everything is wired per-section, so two of these on one page do not fight,
   and re-running is safe: Shopify re-renders a section's markup wholesale in
   the theme editor, which hands us fresh elements each time.
*/
(function () {
  'use strict';

  function setup(root) {
    var track = root.querySelector('[data-ta-tf-track]');
    var prev = root.querySelector('[data-ta-tf-prev]');
    var next = root.querySelector('[data-ta-tf-next]');
    if (!track || !prev || !next) return;

    /* One slide plus its gap. Measured rather than assumed, because the slide
       width is a viewport unit on small screens. */
    function step() {
      var slide = track.querySelector('.ta-tf__slide');
      if (!slide) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    function sync() {
      /* 1px of slack: sub-pixel layout means scrollLeft rarely lands exactly on
         the maximum, and without it the next arrow never hides. */
      var max = track.scrollWidth - track.clientWidth;
      var overflowing = max > 1;
      prev.hidden = !overflowing || track.scrollLeft <= 1;
      next.hidden = !overflowing || track.scrollLeft >= max - 1;
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });

    next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);

    /* ResizeObserver catches the images landing, which changes scrollWidth
       after load without any scroll or resize event firing. */
    if (typeof ResizeObserver === 'function') {
      new ResizeObserver(sync).observe(track);
    }

    sync();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-ta-tf]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* The theme editor replaces a section's markup on every settings change. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
